import * as React from 'react'
import { HeatmapChartLoader, useAlert, useEffectWithPolling } from 'uxp/components'
import { IWidgetTemplateInstanceProps, IWidgetTemplateProps, registerCardTemplate, wrapPropertyEditor } from '../../../common/common'
import { generateIconProp } from '../../../common/icon-selector/IconEditor'
import { createDefaultPropsForWidgetWrapperWithSidebar, WidgetWrapperWithSidebar } from '../../../common/widget-wrappers/WidgetWrapperWithSidebar'
import { IAction } from '../../../common/action-editor/ActionEditor'
import { roundOffValue } from '../../../common/ui-props/RoundOffProperty'
import { HeatMapUI, IHeatMapCellStyle, generateSampleHeatMapData } from '../../../common/heatmap-ui/HeatMapUI'
import { IContextData, appendRowToContextData, useInitialContextData } from '../../../../hooks/useContextData'
import { HeatMapPropertyEditor } from '../../../common/ui-fields/heatmap/HeatMapField'
import WDFilterPanel from '../../../common/components/WDFilterPanel'
import ActionRenderComponent from '../../../common/components/ActionRenderComponent'
import './HeatMapTemplate.scss'
import { executeAndBind, processInitialSource } from '../../../common/data-source-picker/datasource'
import { convertColor, hasValue } from '../../../../util'

const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {
    let uiProps = props?.uiProps || {};
    const alerts = useAlert()
    const forceRerender = React.useRef<number>(0)

    const [loading, setLoading] = React.useState(false)
    const [actionData, setActionData] = React.useState<{ action: IAction, contextData: IContextData }>({ action: null, contextData: {} })
    const [contextData, setContextData] = React.useState<IContextData>({})
    const [chartData, setChartData] = React.useState<any>(null)
    const [initialSource, setIntitialSource] = React.useState(props.initialSource);

    const containerRef = React.useRef(null)
    const { isLoading, initialContextData } = useInitialContextData(props, [uiProps?.source])

    console.log('HMHMH', uiProps);

    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
        'heatmap': wrapPropertyEditor(HeatMapPropertyEditor, {
            binding: null,
            aggregation: 'average',
            fieldLabel: {},
            subYAxisEnabled: false,
            valueField: '',
            xAxis: { type: 'hour', field: '{$.row.time}' },
            yAxis: { type: 'dayofweek', field: '{$.row.time}' },
            cellBorder: true,
            cellBorderColor: '#EFEFEF',
            cellColors: [],
            valueUnits: '',
        }),
    });


    React.useImperativeHandle(ref, () => ({
        beforeSave: validateBeforeSave,
        onPreview: validateBeforeSave
    }))

    React.useEffect(() => {
        return () => {
            props.designer?.removeErrors?.(['datasource', 'field'])
        }
    }, [])

    React.useEffect(() => {
        if (!isLoading) {
            setContextData(prev => ({ ...prev, ...initialContextData }))
        }
    }, [isLoading])

    React.useEffect(() => {
        validateBeforeSave()
    }, [uiProps])

    React.useEffect(() => {
        processInitialSource(props.designer, props.uxpContext, props.uiProps, initialSource, 'dictionary-array')
            .then(res => {
                if (res) props.designer?.setUIProps(res)
            })
            .catch(e => {
                console.log('exception ', e);

            })
    }, [initialSource])


    useEffectWithPolling(props.uxpContext, "heatmap/1", 60000, async () => {

        loadData();

    }, [props.designer?.mode, contextData]);





    function loadData() {
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            let data = generateSampleHeatMapData();
            setChartData(data);
            return
        }
        if (!uiProps?.heatmap?.binding) {
            console.error('No binding for heatmap', uiProps);
            return;
        }
        let binding = uiProps.heatmap.binding;
        setLoading(true)
        let params: any = { filters: contextData?.filters || {} }
        console.log('DDDDSSS', uiProps, binding);
        executeAndBind(props.uxpContext, binding, uiProps.datasources, params, contextData)
            .then(res => {

                setChartData(res)
            })
            .catch(e => {
                setChartData([])
                console.log('error getting data', e)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    // this will be called before save
    function validateBeforeSave() {
        if (!isDataSourceValid()) return false
        if (!hasFieldsConfigured()) return false
        return true
    }

    function isDataSourceValid() {
        if (!hasValue(uiProps?.heatmap?.binding) || !hasValue(uiProps?.heatmap?.binding?.source) || !hasValue(uiProps.heatmap?.binding?.path)) {
            props.designer?.addErrors?.([{
                id: 'datasource',
                type: 'property',
                error: 'Data source is required',
                containerId: 'heatmap-container',
                fieldId: 'source'
            }])
            return false
        }
        props.designer?.removeErrors?.(['datasource'])
        return true
    }

    function hasFieldsConfigured() {
        if (!hasValue(uiProps?.heatmap?.valueField)) {
            props.designer?.addErrors?.([{
                id: 'value-field',
                type: 'property',
                error: 'Value field is required',
                containerId: 'heatmap-container',
                fieldId: 'value-field'
            }])
            return false
        }
        props.designer?.removeErrors?.(['value-field'])


        return true
    }



    function handleChartClick() {

        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            return
        }
        // setActionData({ action: onClickChart || null, contextData: { ...contextData } })
    }

    const heatMapProps = { ...XPRProps.heatmap.defaults, ...(props.uiProps?.heatmap || {}) };

    return <WidgetWrapperWithSidebar
        isInnerField={props?.isInnerField}
        containerRef={containerRef}
        className='uxp-custom-heatmap-chart-template'
        contextData={appendRowToContextData(contextData, props, uiProps.source)}
        propDef={XPRProps}
        uiProps={uiProps}
        showFilterWithoutFields={(uiProps?.filter?.enableExport == false) ? false : true}
        elementId='heatmap-container'
        designer={props.designer}
        defaultTitle='Heat Map'
        filterSection={() => {
            return <WDFilterPanel
                designer={props.designer}
                uxpContext={props.uxpContext}
                uiProps={uiProps}
                containerRef={containerRef}
                data={appendRowToContextData(contextData, props, uiProps.source)}
                onChangeFilters={(data) => {
                    setContextData(prev => ({ ...prev, filters: data?.filters || {} }))
                }}
                onClearFilters={() => {
                    setContextData(prev => ({ ...prev, filters: {} }))
                }}
                onOpenPanel={() => { }}
            />
        }}>
        {
            ((isLoading || loading) && (!chartData || chartData.length == 0))
                ? <HeatmapChartLoader />
                : <HeatMapUI
                    uxpContext={props.uxpContext}
                    contextData={contextData}
                    data={chartData || []}
                    cellFormatter={(v) => {
                        if (v == null || typeof v == 'undefined') return '';
                        var x = roundOffValue(v, heatMapProps.roundOff).toString();
                        if (heatMapProps.valueUnits) x += heatMapProps.valueUnits;
                        return x;
                    }}
                    aggregation={heatMapProps.aggregation}
                    subYAxisEnabled={heatMapProps.subYAxisEnabled}
                    cellBorder={heatMapProps.cellBorder}
                    cellStyle={heatMapProps.cellStyle as (IHeatMapCellStyle)}
                    cellBorderColor={convertColor(heatMapProps.cellBorderColor,contextData)}
                    cellColors={heatMapProps.cellColors.map((c:any)=>({...c,color:convertColor(c.color,contextData)}))}
                    emptyCellColor={convertColor(heatMapProps.emptyCellColor,contextData)}
                    showCellLabels={heatMapProps.showCellLabels}
                    subYAxisBackground={convertColor(heatMapProps.subYAxisBackground,contextData)}
                    subYAxisForeground={convertColor(heatMapProps.subYAxisForeground,contextData)}
                    valueField={heatMapProps.valueField}
                    xAxis={heatMapProps.xAxis}
                    yAxis={heatMapProps.yAxis}
                    xAxisBackground={convertColor(heatMapProps.xAxisBackground,contextData)}
                    xAxisForeground={convertColor(heatMapProps.xAxisForeground,contextData)}
                    yAxisBackground={convertColor(heatMapProps.yAxisBackground,contextData)}
                    yAxisForeground={convertColor(heatMapProps.yAxisForeground,contextData)}
                    yAxisSecondary={heatMapProps.yAxisSecondary}
                    backgroundColor={'transparent'}

                />
        }

        <ActionRenderComponent
            designer={props.designer}
            uxpContext={props.uxpContext}
            {...actionData}
            onClose={() => setActionData({ action: null, contextData: {} })}
            onReloadWidget={() => { }}
        />

    </WidgetWrapperWithSidebar>
})


registerCardTemplate({
    id: 'heatmap',
    name: 'Heatmap',
    description: 'A heatmap to show 3-dimensional data',
    template: XPR,
    icon: generateIconProp('thLarge'),
    complexity: 'medium',
    preLoader: 'heatmap-chart',
    expectedSchema: 'dictionary-array',
    canDragDropFields: true,
});
